module.exports = __webpack_public_path__ + "assets/img/icon-3.217fe950.png";